var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('img',{attrs:{"src":require("../assets/samaggi.png"),"height":"120"}}),_c('h1',[_vm._v("My Samaggi Account")]),_c('SignedInUser')],1)}
var staticRenderFns = []

export { render, staticRenderFns }